import React, { useEffect, useState } from 'react'
import { Sidebar } from '../../components/Sidebar/Sidebar'
import { Link, useParams } from 'react-router-dom'
import logo from '../../assets/i.png'
import { EditModal } from '../../components/AddStudent/EditModal'
import axios from 'axios'
import { Baseurl } from '../../../Config/Baseurl'
import moment from 'moment/moment'

export const EditStudent = () => {
  const [data, setData] = useState([])
  const params = useParams()

  const getData = async () => {
    await axios
      .post(Baseurl.nodeLocal + 'auth/fetchStudentById', {
        id: params.id,
      })
      .then((res) => {
        setData(res.data.data[0])
      })
      .catch((err) => {})
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="row">
      <div className="col-md-2">
        <Sidebar />
      </div>
      <div className="col-md-9 mt-4 p-2 d-flex align-items-center justify-content-center flex-column mx-5">
        <div className="d-flex justify-contetn-center">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/examdashboard" className="link text-primary">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/viewstudents" className="link text-primary">
                  Students List
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                {data.name}
              </li>
            </ol>
          </nav>
        </div>
        <div className="card p-2 w-100">
          <div className="row">
            <div className="col-md">
              <div className="row">
                <div className="col-md-4 d-flex justify-content-center align-items-center">
                  <img
                    src={logo}
                    className="rounded-circle float-left"
                    alt="..."
                    height={100}
                  />
                </div>
                <div className="col-md-8 p-2">
                  <h5 className="mb-3"> {data.name}</h5>

                  <h6 className="d-flex">
                    Email :<h6 className="text-muted">&nbsp; {data.email}</h6>
                  </h6>
                  <h6 className="d-flex">
                    Contact :{' '}
                    <h6 className="text-muted">&nbsp;+91-{data.contact}</h6>
                  </h6>

                  <EditModal id={params.id} />
                </div>
              </div>
            </div>
            <div className="col-md">
              <h5 className="text-primary mb-4">Candidate Details</h5>
              <div className="row mb-1">
                <div className="col-md-4">
                  <h6>College :</h6>
                </div>
                <div className="col-md-8 text-start">
                  <h6 className="text-muted">{data.institute}</h6>
                </div>
              </div>
              <div className="row mb-1">
                <div className="col-md-4">
                  <h6>Course :</h6>
                </div>
                <div className="col-md-8 text-start">
                  <h6 className="text-muted">{data.course}</h6>
                </div>
              </div>
              <div className="row mb-1">
                <div className="col-md-4">
                  <h6>Academic Year :</h6>
                </div>
                <div className="col-md-8 text-start">
                  <h6 className="text-muted">{data.academic_year}</h6>
                </div>
              </div>
              <div className="row mb-1">
                <div className="col-md-4">
                  <h6>Enrollment :</h6>
                </div>
                <div className="col-md-8 text-start">
                  <h6 className="text-muted">{data.enrollment}</h6>
                </div>
              </div>
              <div className="row mb-1">
                <div className="col-md-4">
                  <h6>Recruitment :</h6>
                </div>
                <div className="col-md-8 text-start">
                  <h6 className="text-muted">{data.ins_status}</h6>
                </div>
              </div>
              <div className="row mb-1">
                <div className="col-md-4">
                  <h6>Position Applied For :</h6>
                </div>
                <div className="col-md-8 text-start">
                  <h6 className="text-muted">{data.applied_for}</h6>
                </div>
              </div>
              <div className="row mb-1">
                <div className="col-md-4">
                  <h6>Assigned Exam :</h6>
                </div>
                <div className="col-md-8 text-start">
                  <h6 className="text-muted">{data.exam_name}</h6>
                </div>
              </div>
              <div className="row mb-1">
                <div className="col-md-4">
                  <h6>Exam Start Date :</h6>
                </div>
                <div className="col-md-8 text-start">
                  <h6 className="text-muted">
                    {moment(data.start_date).format('DD/MM/YYYY HH:mm')}
                  </h6>
                </div>
              </div>
              <div className="row mb-1">
                <div className="col-md-4">
                  <h6>Exam End Date :</h6>
                </div>
                <div className="col-md-8 text-start">
                  <h6 className="text-muted">
                    {' '}
                    {moment(data.end_date).format('DD/MM/YYYY HH:mm')}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
